import { Component } from "react"

import moment from "moment"

import { Person } from "../../libs/user/Person"
import { Place } from "../address/AutoSelectionAddress"

import { ADD_UPDATE_PERSON_URL, CALCULATE_CF_URL, ADDRESS_SEARCH_URL } from '../../costants'

import { 
    EMAIL_PATTERN, PHONE_NUMBER_PATTERN, NAMES_PATTERN, STREET_ADDRES_PATTERN, STREET_NAME_PATTERN,
    isValid, isEmpty,
    isValidCityName
} from "../../libs/validation/stringRegex"
import { isNotValiDataNascita } from "../../libs/validation/dateValidation"

import { authFetch } from '../../libs/cookie/Cookie'

export interface PersonProps {
    person?: Person

    profList: any | undefined
    statiList: any | undefined

    callbackUser: Function | undefined
    expiredSessionCallbak: Function

    hideProfessione?: boolean

    peopleRole?: string
}

export interface PersonState {
    isOpen: boolean

    id: string | undefined

    nome: string |undefined,
    cognome: string | undefined
    email: string | undefined
    cellulare: string | undefined

    indirizzoResidenza: string | undefined
    street?: string | undefined
    street_number?: string | undefined
    zip?: string | undefined
    city?: string | undefined

    is_manual_address: boolean

    natoInItalia: boolean | undefined
    sesso: number | undefined
    dataNascita: string | undefined
    stato_nascita: number | undefined
    comune_nascita: string | undefined
    professione: string | undefined
    codiceFiscale?: string | undefined

    nomeError?: string | undefined
    cognomeError?: string | undefined
    emailError?: string | undefined
    phoneError?: string | undefined

    indirizzoResidenzaError?: string | undefined
    streetError?: string | undefined
    street_numberError?: string | undefined
    zipError?: string | undefined
    cityError?: string | undefined
    
    natoInItaliaError?: string | undefined
    sessoError?: string | undefined
    dataNascitaError?: string | undefined
    stato_nascitaError?: string | undefined
    comune_nascitaError?: string | undefined
    profeError?: string | undefined

    globalError?: string | undefined

    waith: boolean
}

/**
 * ATTENZIONE -- eredità multipla!
 */
class PersonEdit <T extends PersonProps, P extends PersonState>
    extends Component<T,P> {

        constructor(props: any){ 
            super(props)

            this.toggle = this.toggle.bind(this)

            this.updateName = this.updateName.bind(this)
            this.updateCognome = this.updateCognome.bind(this)
            this.updateEmail = this.updateEmail.bind(this)
            this.updateCellulare = this.updateCellulare.bind(this)
            this.updateProfessione = this.updateProfessione.bind(this)

            this.updateSesso = this.updateSesso.bind(this)
            this.updateDataNascita = this.updateDataNascita.bind(this)
            this.updateNatoInItalia = this.updateNatoInItalia.bind(this)
            this.updateStato_nascita = this.updateStato_nascita.bind(this)
            this.updateComune_nascita = this.updateComune_nascita.bind(this)

            this.updateIndirizzoResidenza = this.updateIndirizzoResidenza.bind(this)
            this.setIndirizzo = this.setIndirizzo.bind(this)
            this.updateStreet = this.updateStreet.bind(this)
            this.updateStreet_number = this.updateStreet_number.bind(this)
            this.updateZip = this.updateZip.bind(this)
            this.updateCity = this.updateCity.bind(this)
            this.updateAllAddressParts = this.updateAllAddressParts.bind(this)

            this.getValidationError = this.getValidationError.bind(this)
            this.printError = this.printError.bind(this)

            this.clearNameError = this.clearNameError.bind(this)
            this.clearCognomeError = this.clearCognomeError.bind(this)
            this.clearEmailError = this.clearEmailError.bind(this)
            this.clearCellulareError = this.clearCellulareError.bind(this)
            this.clearProfessioneError = this.clearProfessioneError.bind(this)
            this.clearSessoError = this.clearSessoError.bind(this)
            this.clearDataNascitaError = this.clearDataNascitaError.bind(this)
            this.clearNatoInItaliaError = this.clearNatoInItaliaError.bind(this)
            this.clearComune_nascitaError = this.clearComune_nascitaError.bind(this)
            this.clearStato_nascitaError = this.clearStato_nascitaError.bind(this)
            this.clearIndirizzoResidenzaError = this.clearIndirizzoResidenzaError.bind(this)

            this.sendData = this.sendData.bind(this)

            this.updateIsManualAddress = this.updateIsManualAddress.bind(this)
            this.validateAddress = this.validateAddress.bind(this)
        }
        
        // importante: va sovrascritta!
        getInitialState () {
            return {}
        }
        // importante: va sovrascritta!


        getValidationError () : string | undefined {
            if (!isValid(this.state.nome, NAMES_PATTERN)) {
                return 'NOME'
            }
            else if (!isValid(this.state.cognome, NAMES_PATTERN)) {
                return 'COGNOME'
            }
            else if (this.state.sesso === undefined) {
                return 'SESSO'
            }
            else if (this.state.dataNascita === undefined || isNotValiDataNascita(this.state.dataNascita)) {
                return 'DATA_NASCITA'
            }
            else if (this.state.natoInItalia === undefined) {
                return 'NATO_IN_ITALIA';
            }
            else if (this.state.stato_nascita === undefined) {
                return 'STATO_NASCITA'
            }
            else if (Number(this.state.stato_nascita) === 13 && !isValidCityName(this.state.comune_nascita)) {
                return 'COMUNE_NASCITA'
            }
            else if (
                !isValid(this.state.indirizzoResidenza, STREET_ADDRES_PATTERN) &&
                !isValid(this.state.street, STREET_NAME_PATTERN)
            ) {
                return 'INDIRIZZO'
            }
            else if (!isValid(this.state.email, EMAIL_PATTERN)) {
                return 'EMAIL'
            }
            else if (!isValid(this.state.cellulare, PHONE_NUMBER_PATTERN)) {
                return 'PHONE'
            }
            else if ( this.props.hideProfessione !== true && isEmpty(this.state.professione)) {
                return 'PROFESSIONE'
            }

            return undefined
        }

        printError (errorString: string | undefined, waith: boolean = false) {
            let nomeErro = undefined
            let cognErro = undefined

            let sessoErro = undefined
            let dataNascitaErro = undefined
            let natoInItaliaErro = undefined
            let stato_nascitaErro = undefined
            let comune_nascitaErro = undefined
            let indirizzoResidenzaErro = undefined

            let profeErro = undefined
            let emailErro = undefined
            let phoneErro = undefined
            let global = undefined

            if (errorString === 'NOME') {
                nomeErro = 'Nome non valido'
                global= nomeErro
            }
            else if (errorString === 'COGNOME') {
                cognErro = 'Cognome non valido'
                global= cognErro
            }
            else if (errorString === 'SESSO') {
                sessoErro = 'Sesso non valido'
                global = "Selezionare il sesso"
            }
            else if (errorString === 'DATA_NASCITA') {
                dataNascitaErro = 'Data non valida'
                global = "Data di nascita non valida (deve essere maggiorenne)"
            }
            else if (errorString === 'NATO_IN_ITALIA') {
                natoInItaliaErro = 'Stato non valido'
                global = 'Indicare se è nato in Italia o al estero'
            }
            else if (errorString === 'STATO_NASCITA') {
                stato_nascitaErro = 'Stato non valido'
                global = "Selezionare lo stato di nascita"
            }
            else if (errorString === 'COMUNE_NASCITA') {
                comune_nascitaErro = 'Comune non valido'
                global = "Comune di nascita non valido"
            }
            else if (errorString === 'INDIRIZZO' || errorString === 'CONTRACTOR_ADDRESS_NOT_FOUND') {
                indirizzoResidenzaErro = "Indirizzo non valido"
                global = indirizzoResidenzaErro

                if (errorString === 'CONTRACTOR_ADDRESS_NOT_FOUND') {
                    global = 'Indirizzo non trovato, ti preghiamo di inserirlo tramite il tasto "Compilazione manuale".'
                }
            }
            else if (errorString === 'EMAIL') {
                emailErro = 'Email non valida'
                global= emailErro
            }
            else if (errorString === 'PHONE') {
                phoneErro = 'Cellulare non valido'
                global= phoneErro
            } 
            else if (errorString === 'PROFESSIONE') {
                profeErro = 'Selezionare un valore'
                global= profeErro
            } 

            this.setState ({
                waith: waith,
                nomeError: nomeErro,
                cognomeError: cognErro,
                sessoError: sessoErro,
                dataNascitaError: dataNascitaErro,
                natoInItaliaError: natoInItaliaErro,
                stato_nascitaError: stato_nascitaErro,
                comune_nascitaError: comune_nascitaErro,
                indirizzoResidenzaError: indirizzoResidenzaErro,
                emailError: emailErro,
                phoneError: phoneErro,
                profeError: profeErro,
                globalError: global
            })
        }

        sendData () {
            let error = this.getValidationError()

            console.log ("chiamato")

            if (error === undefined) {
                this.validateAddress().then( (res: any) => {
                    error = res

                    const waith = error === undefined

                    this.printError(error, waith);

                    if (waith) {

                        const tmp = this.state.comune_nascita?.split("(")

                        const sesso = (this.state.sesso === 0 || (this.state.sesso as any) === 'uomo') ? 0 : 1

                        // ottengo il codice fiscale
                        const requestBody = {
                            nome: this.state.nome,
                            cognome: this.state.cognome,
                            data: this.state.dataNascita,
                            sesso: sesso,
                            comune: (tmp) ? tmp[0].trim().toUpperCase() : null,
                            provincia: (tmp) ? tmp[1].trim().replace(")", "") : null,
                            nazione: this.state.stato_nascita
                        }

                        authFetch (
                            CALCULATE_CF_URL,
                            {
                                method: 'post',
                                body: JSON.stringify( requestBody )
                            },
                            this.props.expiredSessionCallbak
                        )
                        .then ((res: any) => {
                            const cf = (res?.msg === 'ok')
                                ? res?.obj?.fiscalCode
                                : undefined

                            this.setState({
                                codiceFiscale: cf
                            }, () => {
                                // aggiorno SF
                                const dateOfBirth = (this.state.dataNascita !== undefined) ? this.state.dataNascita + 'T00:00:00.000Z' : undefined

                                const statoName = (this.props.statiList as Array<any>).filter ( 
                                    (s: any) => s.id === this.state.stato_nascita
                                )[0]?.value
                                
                                const cCityOfBirth = {
                                    id: this.state.comune_nascita,
                                    value: this.state.comune_nascita
                                }
                                const cCountryOfBirth = {
                                    id: this.state.stato_nascita,
                                    value: statoName
                                }

                                let personData = {
                                    id: this.state.id ?? '',
                                    email: this.state.email,
                                    phone: this.state.cellulare,

                                    name: this.state.nome,
                                    surname: this.state.cognome,
                                    gender: (this.state.sesso === undefined) ? undefined : (Number(this.state.sesso) === 0 ? 'uomo' : 'donna'),
                                    dateOfBirth: dateOfBirth,
                                    bornInItaly: this.state.natoInItalia,
                                    countryOfBirth: cCountryOfBirth,
                                    cityOfBirth: cCityOfBirth,
                                    fiscalCode: this.state.codiceFiscale,

                                    address: this.state.street,
                                    addressNumber: this.state.street_number,
                                    postalCodeOfResidence: this.state.zip,
                                    cityOfResidence: {id: this.state.city, value: this.state.city},

                                    profession: this.state.professione,
                                }

                                if (!isEmpty(this.state.id)) {
                                    personData = {
                                        ...personData,
                                        ...{
                                            updated_at: moment().format('YYYY-MM-DD[T]HH:mm:ss[Z]'),
                                        }
                                    }
                                }
                                
                                authFetch (
                                    ADD_UPDATE_PERSON_URL,
                                    {
                                        method: "post",
                                        body: JSON.stringify(
                                            personData
                                        )
                                    },
                                    this.props.expiredSessionCallbak
                                )
                                .then ( jsonObj => {

                                    if (jsonObj?.success === false) {
                                        this.printError ( jsonObj.error_code )
                                    } 
                                    else {
                                        this.setState(
                                            this.getInitialState(), 
                                            () => {
                                                if (this.props.callbackUser) {
                                                    this.props.callbackUser ()
                                                }
                                            }
                                        )
                                    }
                                })

                            })
                        })
                    }
                })
            }
            else {
                this.printError(error);
            }

        }

        private async validateAddress () {
            const indirizzo = this.state.street + ', ' +
                    this.state.street_number + ', ' +
                    this.state.zip + ' ' +
                    this.state.city + ', ITALIA'

            if (this.state.is_manual_address === true) {
                return undefined
            }
            else if (isEmpty(indirizzo)) {
                return 'CONTRACTOR_ADDRESS_NOT_FOUND'
            }
            else {
                const abortController = new AbortController()

                let p = await authFetch (
                    ADDRESS_SEARCH_URL,
                    {
                        method: 'post',
                        body: JSON.stringify( indirizzo ),
                        signal: abortController?.signal
                    },
                    this.props.expiredSessionCallbak
                ).then( (res: any) => {
                    let palces = (res.placeList as Array<any>)

                    let hearAddress = indirizzo
                    hearAddress = hearAddress?.replace("(", "").replace(")", "")

                    if (palces === undefined || !palces.some ( (c: Place) => c.description.toUpperCase() === hearAddress )) {
                        console.log (
                            hearAddress,
                            palces
                        )
                        return 'CONTRACTOR_ADDRESS_NOT_FOUND'    
                    }
                    

                    return undefined
                }).catch( async (err) => {
                    return 'CONTRACTOR_ADDRESS_NOT_FOUND'
                })

                return p
            }
        }

        updateName (val: string | undefined) {
            this.setState({
                nome: val,
                nomeError: undefined,
                globalError: undefined
            })
        }
        updateCognome (val: string | undefined) {
            this.setState({
                cognome: val,
                cognomeError: undefined,
                globalError: undefined
            })
        }
        updateEmail (val: string | undefined) {
            this.setState({
                email: val,
                emailError: undefined,
                globalError: undefined
            })
        }
        updateCellulare (val: string | undefined) {
            this.setState({
                cellulare: val,
                cognomeError: undefined,
                globalError: undefined
            })
        }
        updateProfessione (val: string | undefined) {
            this.setState({
                professione: val,
                profeError: undefined,
                globalError: undefined
            })
        }

        updateSesso (val: number | undefined) {
            this.setState({
                sesso: val,
                sessoError: undefined,
                globalError: undefined
            })
        }
        updateDataNascita (val: string | undefined) {
            this.setState({
                dataNascita: val,
                dataNascitaError: undefined,
                globalError: undefined
            })
        }
        updateNatoInItalia (val: boolean | undefined) {
            this.setState({
                natoInItalia: val,
                natoInItaliaError: undefined,
                globalError: undefined
            })
        }
        updateStato_nascita (val: number | undefined) {
            this.setState({
                stato_nascita: val,
                stato_nascitaError: undefined,
                globalError: undefined
            })
        }
        updateComune_nascita (val: string | undefined) {
            this.setState({
                comune_nascita: val,
                comune_nascitaError: undefined,
                globalError: undefined
            })
        }

        updateIndirizzoResidenza (val: string | undefined) {
            this.setState({
                indirizzoResidenza: val,
                indirizzoResidenzaError: undefined,
                globalError: undefined
            })
        }
        setIndirizzo () {
            if (
                    !isEmpty(this.state.street) &&
                    !isEmpty(this.state.street_number) &&
                    !isEmpty(this.state.zip) &&
                    !isEmpty(this.state.city)
            ) {
                const completeAddress = this.state.street + ', ' +
                    this.state.street_number + ', ' +
                    this.state.zip + ' ' +
                    this.state.city + ', ITALIA'

                this.setState({
                    indirizzoResidenza: completeAddress,
                    indirizzoResidenzaError: undefined,
                    globalError: undefined
                })
            }
        }

        updateStreet (val: string | undefined) {
            this.setState({
                street: val?.toUpperCase(),
                streetError: undefined,
                indirizzoResidenzaError: undefined,
                globalError: undefined
            }, () => {
                this.setIndirizzo()
            })
        }
        updateStreet_number (val: string | undefined) {
            this.setState({
                street_number: val,
                streetError: undefined,
                street_numberError: undefined,
                indirizzoResidenzaError: undefined,
                globalError: undefined
            }, () => {
                this.setIndirizzo()
            })
        }
        updateZip (val: string | undefined) {
            this.setState({
                zip: val,
                zipError: undefined,
                indirizzoResidenzaError: undefined,
                globalError: undefined
            }, () => {
                this.setIndirizzo()
            })
        }
        updateCity (val: string | undefined) {
            this.setState({
                city: val,
                cityError: undefined,
                indirizzoResidenzaError: undefined,
                globalError: undefined
            }, () => {
                this.setIndirizzo()
            })
        }
        updateAllAddressParts(
            pStreet: string | undefined | null,
            pStreet_number: string | undefined | null,
            pZip: string | undefined | null,
            pCity: string | undefined | null
        ) {
            this.setState({
                street: (pStreet === null) ? undefined : pStreet?.toUpperCase(),
                street_number: (pStreet_number === null) ? undefined : pStreet_number,
                zip: (pZip === null) ? undefined : pZip,
                city: (pCity === null) ? undefined : pCity,
            }, () => {
                this.setIndirizzo()
            })
        }

        clearNameError () {
            this.setState({
                nomeError: undefined
            })
        }
        clearCognomeError () {
            this.setState({
                cognomeError: undefined
            })
        }
        clearEmailError () {
            this.setState({
                emailError: undefined
            })
        }
        clearCellulareError () {
            this.setState({
                phoneError: undefined
            })
        }
        clearProfessioneError () {
            this.setState({
                profeError: undefined
            })
        }
        clearSessoError () {
            this.setState({
                sessoError: undefined
            })
        }
        clearDataNascitaError () {
            this.setState({
                dataNascitaError: undefined
            })
        }
        clearNatoInItaliaError () {
            this.setState({
                natoInItaliaError: undefined
            })
        }
        clearComune_nascitaError () {
            this.setState({
                comune_nascitaError: undefined
            })
        }
        clearStato_nascitaError () {
            this.setState({
                stato_nascitaError: undefined
            })
        }
        clearIndirizzoResidenzaError () {
            this.setState({
                indirizzoResidenzaError: undefined
            })
        }

        toggle (e: React.MouseEvent<HTMLSpanElement>) {
            if (e?.stopPropagation && e.preventDefault) {
                e.stopPropagation()
                e.preventDefault()
            }

            this.setState ({
                isOpen: !this.state.isOpen
            })
        }

        voidFunction () {}

        updateIsManualAddress ( val: boolean) {
            this.setState({
                is_manual_address: val
            })
        }

}

export default PersonEdit